import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalContent} from '@spothero/ui-backlog';
import DOMUtils from '@spothero/utils/dom';
import SpotDetailsDirectionsMap from '../directions-map';

export default class SpotDetailsDirectionsMapModal extends PureComponent {
    static propTypes = {
        spotLatitude: PropTypes.number.isRequired,
        spotLongitude: PropTypes.number.isRequired,
        destinationLatitude: PropTypes.number.isRequired,
        destinationLongitude: PropTypes.number.isRequired,
        isDriving: PropTypes.bool,
        linearMeters: PropTypes.number,
        walkingInMeters: PropTypes.number,
        walkingDuration: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
        onHidden: PropTypes.func.isRequired,
    };

    componentDidMount() {
        setTimeout(() => {
            const mapContainer = DOMUtils.el(
                '.SpotDetailsDirectionsMapModal .SpotDetailsDirectionsMap'
            );
            const height = this._calculateContentHeight();

            mapContainer.style.height = `${height}px`;
        }, 100);
    }

    _calculateContentHeight() {
        return (
            DOMUtils.height('.Modal-wrapper') -
            DOMUtils.height('.Modal-title') -
            32
        ); // .Modal-content padding times 2
    }

    render() {
        const {
            spotLatitude,
            spotLongitude,
            destinationLatitude,
            destinationLongitude,
            isDriving,
            linearMeters,
            walkingInMeters,
            walkingDuration,
            onHidden,
        } = this.props;
        const walkingProps = {
            linearMeters,
            walkingInMeters,
            walkingDuration,
        };

        return (
            <Modal
                className="SpotDetailsDirectionsMapModal"
                title="Location"
                onHidden={onHidden}
            >
                <ModalContent contentAreaHeight={this._calculateContentHeight}>
                    <SpotDetailsDirectionsMap
                        spotLatitude={spotLatitude}
                        spotLongitude={spotLongitude}
                        destinationLatitude={destinationLatitude}
                        destinationLongitude={destinationLongitude}
                        isDriving={isDriving}
                        isDraggable
                        {...(!isDriving && walkingProps)}
                    />
                </ModalContent>
            </Modal>
        );
    }
}
